import { computed, type MaybeRefOrGetter, toValue } from 'vue';
import { useI18n } from '@cvo/i18n/composables/useI18n';
import type { InvoiceStatus } from '@cvo/domain';
import type { TagType } from '@cvo/ui/components/atoms/Tag/Tag.model';

interface InvoiceStatusConfig {
  label: string;
  tagStatus: TagType;
}

export const INVOICE_STATUS_MAP: Record<InvoiceStatus, InvoiceStatusConfig> = {
  UNPAID:             { label: 'ui.subscription.outstandingBalance.status.notPaid',           tagStatus: 'warning' },
  PARTIALLY_PAID:     { label: 'ui.subscription.outstandingBalance.status.partiallyPaid',     tagStatus: 'warning' },
  PARTIALLY_REFUNDED: { label: 'ui.subscription.outstandingBalance.status.partiallyRefunded', tagStatus: 'information' },
  PAID:               { label: 'ui.subscription.outstandingBalance.status.paid',              tagStatus: 'success' },
  REFUNDED:           { label: 'ui.subscription.outstandingBalance.status.refunded',          tagStatus: 'information' },
};

export function useInvoiceStatus(status: MaybeRefOrGetter<InvoiceStatus>) {
  const { t } = useI18n();
  const config = computed(() => INVOICE_STATUS_MAP[toValue(status)]);

  return {
    tagStatus: computed(() => config.value.tagStatus),
    statusLabel: computed(() => t(config.value.label)),
  };
}
